module.exports = __webpack_public_path__ + "img/Yoko.6fea6eaa.png";